import React from 'react';

function Header() {
  return (
    <header className="tc-inner-header-style1 pb-100">
      <div className="container">
        <div className="info">
          <h2 className="js-title fsz-100"> Contact </h2>
          <div className="text fsz-18 color-666">
              <br/>
            Want to chat further? We’d love to hear from you{' '}
            <br /> Contact us to discuss your next project{' '}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
